import { render, staticRenderFns } from "./Inject.vue?vue&type=template&id=0be9d7aa"
import script from "./Inject.vue?vue&type=script&lang=js"
export * from "./Inject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports